import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './i18n';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
// import LoadingSpinner from './components/LoadingSpinner';
import SharkAnimation from './components/SharkAnimation';
import ClownfishAnimation from './components/ClownfishAnimation';
import TroutAnimation from './components/TroutAnimation';
import RealisticOcean from './components/RealisticOcean';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Menu from './pages/Menu';
import Gallery from './pages/Gallery';
import FindUs from './pages/FindUs';
import LegalMentions from './pages/LegalMentions';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        {/* Global Site Background */}
        <div className="site-bg-layer">
          <video autoPlay muted loop playsInline>
            <source src="/images/herovideo.MOV" type="video/mp4" />
          </video>
        </div>
        
        {/* Sophisticated Ocean Background with Marine Life */}
        <div className="ocean-background">
          
          {/* Floating Bubbles */}
          {[...Array(12)].map((_, i) => {
            const size = Math.random() * 8 + 3; // 3-11px for more variety
            return (
              <div
                key={`bubble-${i}`}
                className="bubble"
                style={{
                  left: `${Math.random() * 100}%`,
                  bottom: `-${Math.random() * 100 + 50}px`,
                  width: `${size}px`,
                  height: `${size}px`,
                  animationDelay: `${i * 1.2 + Math.random() * 5}s`,
                  animationDuration: `${25 + Math.random() * 20}s`,
                  opacity: 0.3 + Math.random() * 0.4 // 0.3-0.7 opacity
                }}
              />
            );
          })}
          
          {/* Realistic Ocean Effect */}
          <RealisticOcean />
          
          {/* Clownfish Animation in Clear Water */}
          <ClownfishAnimation />
          
          {/* Trout Animation in Mid Water */}
          <TroutAnimation />
          
          {/* Shark Animation with Transparent Background */}
          <SharkAnimation />
          
          {/* Coral Reef Decorations */}
          <div className="coral-reef">
            <div className="coral coral-1"></div>
            <div className="coral coral-2"></div>
            <div className="coral coral-3"></div>
          </div>
        </div>
        
        <Header />
        
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/find-us" element={<FindUs />} />
            <Route path="/legal" element={<LegalMentions />} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;
